import React from "react"
import { HeaderSection } from "../../common/headers/HeaderSection";
import FreeCourseScheduleSection from "./FreeCourseBanner";
import { CourseSchedule } from "@/interfaces/CourseSchedule";

const mobileappWeek1FreeCourseSchedule: CourseSchedule[] = [
    {
        id: 1,
        programTitle: 'Mobile Application',
        date: '12 Desember 2023',
        day: 'Selasa',
        time: '19.00 - selesai',
    },
];
const mobileappWeek2FreeCourseSchedule: CourseSchedule[] = [
    {
        id: 2,
        programTitle: 'Mobile Application',
        date: '13 Desember 2023',
        day: 'Rabu',
        time: '19.00 - selesai',
    },
];
const mobileappWeek3FreeCourseSchedule: CourseSchedule[] = [
    {
        id: 3,
        programTitle: 'Mobile Application',
        date: '19 Desember 2023',
        day: 'Selasa',
        time: '19.00 - selesai',
    },
];

const MobileAppFreeCourseSchedule = () => {
    return (
        <div className="px-5 md:px-10">
            <HeaderSection
                title="Jadwal Program"
                subtitle="Pilih dan daftar jadwal program yang tersedia"
            />
            <FreeCourseScheduleSection schedule={mobileappWeek1FreeCourseSchedule} />
            <FreeCourseScheduleSection schedule={mobileappWeek2FreeCourseSchedule} />
            <FreeCourseScheduleSection schedule={mobileappWeek3FreeCourseSchedule} />
        </div>
    );
};

export default MobileAppFreeCourseSchedule;